module.exports = __webpack_public_path__ + "static/media/gas_price.c753d531.svg";